import {s3Link} from "../../utils/constants";
import React from "react";

const Subcovers = ({
    subcovers
}) => {
    return <>
        <div className='subcovers-container'>
            {
                subcovers && subcovers.length > 0 && <div className={'subcovers'}>
                    {
                        subcovers.map((cover, index) => {
                            if (cover.type === 'image' || cover.type === 'IMAGE' || cover.type === 'Image')
                                return <div className="image-container" key={`${cover.media_id}-${index}`}>
                                    <img key={`${cover.media_id}-${index}`} onContextMenu={e => e.preventDefault()} src={`${s3Link}/${cover.file_path}`} key={cover.media_id} alt={cover.type}/>
                                </div>
                        })
                    }
                </div>
            }
        </div>
    </>
};

export default Subcovers;
